import { createAsyncActionType } from './index';

export const COURSE_LIST_GET = createAsyncActionType(
  'courselist',
  'COURSE_LIST_GET'
);

export const MODULE_LIST_GET = createAsyncActionType(
  'courselist',
  'MODULE_LIST_GET'
);

export const EVENT_LIST_GET = createAsyncActionType(
  'courselist',
  'EVENT_LIST_GET'
);

export const CATALOGS_GET = createAsyncActionType('courselist', 'CATALOGS_GET');

export const COURSE_CATEGORIES_RESET = '@@courselist/COURSE_CATEGORIES_RESET';
export const COURSE_CATEGORIES_GET = createAsyncActionType(
  'courselist',
  'COURSES_CATEGORIES_GET'
);

export const GLOBAL_COURSE_CATEGORIES_GET = createAsyncActionType(
  'courselist',
  'GLOBAL_COURSE_CATEGORIES_GET'
);

export const LEVELS_GET = createAsyncActionType('courselist', 'LEVELS_GET');
export const FFOO_GET = createAsyncActionType('courselist', 'FFOO_GET');

export const COURSE_LIST_RESET = '@@courselist/COURSE_LIST_RESET';

export const GLOBAL_COURSE_LIST_GET = createAsyncActionType(
  'courselist',
  'GLOBAL_COURSE_LIST_GET'
);

export const GLOBAL_COURSE_LIST_EXPORT = createAsyncActionType(
  'courselist',
  'GLOBAL_COURSE_LIST_EXPORT'
);
